import { Icon } from '@chakra-ui/react';

export default function SFSaveIconOutlined(props) {
  return (
    <Icon
      width='10px'
      height='15px'
      viewBox='0 0 10 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.30192 14.272C0.865723 14.272 0.611816 13.9855 0.611816 13.4777V2.17562C0.611816 0.938639 1.23031 0.307129 2.45426 0.307129H7.54541C8.76937 0.307129 9.38786 0.938639 9.38786 2.17562V13.4777C9.38786 13.9855 9.13395 14.272 8.69775 14.272C8.37874 14.272 8.18994 14.0897 7.604 13.5233L5.05843 11.0168C5.03239 10.9842 4.9738 10.9842 4.94124 11.0168L2.39567 13.5233C1.80973 14.0897 1.62093 14.272 1.30192 14.272ZM1.83577 12.5142L4.65478 9.77978C4.86312 9.57796 5.13656 9.57796 5.34489 9.77978L8.1639 12.5142C8.26156 12.6053 8.35921 12.5793 8.35921 12.4491V2.18864C8.35921 1.62874 8.06624 1.33577 7.49984 1.33577H2.50635C1.93343 1.33577 1.64046 1.62874 1.64046 2.18864V12.4491C1.64046 12.5793 1.74463 12.6053 1.83577 12.5142Z'
        fill='#465772'
      />
    </Icon>
  );
}
